import { c as _c } from "react/compiler-runtime";
import { translate } from '@openclassrooms/translations';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import FAQ from '@classify/react-marketing-components/FAQ';
import Recommended from './Recommended';
export function useStudentFaqEntries() {
  return [{
    question: translate('support.global.faq.options_funding.question'),
    answer: translate('support.global.faq.options_funding.answer')
  }, {
    question: translate('support.global.faq.using_cpf.question'),
    answer: translate('support.global.faq.using_cpf.answer')
  }, {
    question: translate('support.global.faq.prerequisites.question'),
    answer: translate('support.global.faq.prerequisites.answer')
  }, {
    question: translate('support.global.faq.prep_documents.question'),
    answer: translate('support.global.faq.prep_documents.answer')
  }, {
    question: translate('support.global.faq.detailed_info_program.question'),
    answer: translate('support.global.faq.detailed_info_program.answer')
  }, {
    question: translate('support.global.faq.training_costs_devis.question'),
    answer: translate('support.global.faq.training_costs_devis.answer')
  }, {
    question: translate('support.global.faq.connection_issue.question'),
    answer: translate('support.global.faq.connection_issue.answer')
  }, {
    question: translate('support.global.faq.state_recognition.question'),
    answer: translate('support.global.faq.state_recognition.answer')
  }];
}
export default function RecommendedStudent() {
  const $ = _c(3);
  const {
    getLocalisationConfig
  } = useLocalisationConfig();
  const canDisplayFAQBlock = getLocalisationConfig("contact.faq.show");
  const items = useStudentFaqEntries();
  if (!canDisplayFAQBlock) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = translate("global.word.expand");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== items) {
    t1 = <Recommended><FAQ expandAriaLabel={t0} items={items} /></Recommended>;
    $[1] = items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}